<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="tran"><span class="epub-b">TRANSLATOR’S NOTE</span></p>
<p class="tni">The French justice system is somewhat different from that elsewhere. Under French law, when it is believed that a crime has been committed, an officer of the crime unit will inform the district public prosecutor, who in turn appoints an examining magistrate to the case.</p>
<p class="stni">Investigations are conducted under the supervision of these magistrates, who answer to the Ministry of Justice. Crimes may be investigated by police commissioners from the crime unit, along with commissioned officers of the gendarmerie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// trans.vue?34efaa08